import { ConditionSingleValueInput } from './ConditionSingleValueInput';
import { ConditionSingleValueInputProps } from '../types';

/** single value select inputs */
export const ConditionSingleValueStringInput = (props: ConditionSingleValueInputProps<string>) => (
  <ConditionSingleValueInput {...props} type="text" />
);

export const ConditionSingleValueNumberInput = (props: ConditionSingleValueInputProps<string>) => (
  <ConditionSingleValueInput {...props} type="number" />
);
